<template>
    <CompanyBoxContent v-if="owners && owners.length > 0" :title="$t('company.actualOwners') + ':'">
        <template #data>
            <div v-for="(owner, index) in filteredCurrentOwners(owners)" :key="index" class="mt-2 box">
                <div class="mb-2 row">
                    <router-link :to="{ name: 'companiesSameOwner', params: { slug: owner.owner.uuid } }"
                        v-if="owner.owner.name && owner.owner.surname" class="router_link">
                        <span>{{ owner.owner.name }} {{ owner.owner.surname }}</span>
                    </router-link>
                    <div v-if="!owner.owner.bussiness_name" class="row">
                        <span v-if="owner.owner.age">{{ $t('company.age') }}: {{ owner.owner.age }}</span>
                        <span v-if="owner.owner.town">{{ owner.owner.town }}</span>
                    </div>
                    <div v-if="owner.owner.bussiness_name" class="row">
                        <router-link :to="{ name: 'companiesSameOwner', params: { slug: owner.owner.uuid } }"
                            class="router_link">
                            <span>{{ owner.owner.bussiness_name }}</span>
                        </router-link>
                        <span v-if="owner.owner.full_address">{{ owner.owner.full_address }}</span>
                    </div>
                    <span>
                        {{ $t('company.owner') }} {{ $t('general.from') }}
                        <i18n-d v-if="owner.owner_from" tag="span" :value="new Date(owner.owner_from)"></i18n-d>
                    </span>
                </div>
            </div>
            <div v-if="oldOwners && oldOwners.length > 0" class="mt-4">
                <div class="title">
                    <h3>{{ $t('company.oldOwners') }}:</h3>
                </div>
                <div v-for="(owner, index) in filteredOldOwners(owners)" :key="index" class="mt-2 box">
                    <div v-if="owner.owner_to !== null" class="mb-2 row">
                        <router-link :to="{ name: 'companiesSameOwner', params: { slug: owner.owner.next_form.uuid } }"
                            v-if="owner.owner.next_form" class="router_link">
                            <span>{{ owner.owner.name }} {{ owner.owner.surname }}</span>
                        </router-link>
                        <router-link :to="{ name: 'companiesSameOwner', params: { slug: owner.owner.uuid } }" v-else
                            class="router_link">
                            <span>{{ owner.owner.name }} {{ owner.owner.surname }}</span>
                        </router-link>
                        <div v-if="!owner.owner.bussiness_name" class="row">
                            <span v-if="owner.owner.age">{{ $t('company.age') }}: {{ owner.owner.age }}</span>
                            <span v-if="owner.owner.town">{{ owner.owner.town }}</span>
                        </div>
                        <div v-if="owner.owner.bussiness_name" class="row">
                            <router-link :to="{ name: 'companiesSameOwner', params: { slug: owner.owner.uuid } }"
                                class="router_link">
                                <span>{{ owner.owner.bussiness_name }}</span>
                            </router-link>
                            <span v-if="owner.owner.full_address">{{ owner.owner.full_address }}</span>
                        </div>
                        <span>
                            {{ $t('company.owner') }} {{ $t('general.from') }}
                            <i18n-d v-if="owner.datumZapisu" tag="span" :value="new Date(owner.datumZapisu)"></i18n-d>
                            <i18n-d v-if="owner.owner_from" tag="span" :value="new Date(owner.owner_from)"></i18n-d>
                            {{ $t('general.to') }}
                            <i18n-d v-if="owner.datumVymazu" tag="span" :value="new Date(owner.datumVymazu)"></i18n-d>
                            <i18n-d v-if="owner.owner_to" tag="span" :value="new Date(owner.owner_to)"></i18n-d>
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </CompanyBoxContent>
</template>

<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue";

export default {
    props: {
        company: {
            type: Object,
            required: true
        }
    },
    components: {
        CompanyBoxContent
    },
    data() {
        return {
            owners: [],
        }
    },
    created() {
        this.loadData()
    },
    computed: {
        oldOwners() {
            const oldOwnersList = this.filteredOldOwners(this.owners);

            return oldOwnersList;
        }
    },
    methods: {
        loadData() {
            this.$store.getters.api.get(`/company/${this.$route.params.slug}/owners`).then((response) => {
                this.owners = response.data.items;
            });
        },
        filteredCurrentOwners(owners) {
            return owners.filter(owner => owner.owner_to === null);
        },
        filteredOldOwners(owners) {
            // Filter old owners who have a removal date and whose removal date is different from their registration date
            return owners.filter(owner =>
                owner.owner_to && owner.owner_to !== owner.owner_from
            );
        },

    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.title {
    padding: 0 0 5px 20px;

    h3 {
        font-weight: 700;
        font-size: 24px;
    }
}

.router_link {
    cursor: pointer;
    text-decoration: underline;
    color: $black;
}
</style>
